import styled from "styled-components";
import { CircleButton } from "_c/button";
import { OvalPreloader } from "_c/preloader";

export const Preloader = styled(OvalPreloader)`
  width: 25px;
`;
export const Wrap = styled.div`
  margin-bottom: 40px;
  @media (max-width: 991px) {
    margin-bottom: 10px;
  }
`;
export const SliderWrap = styled.div`
  min-height: 170px;
  display: flex;
  width: 95%;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  justify-content: flex-start;
  flex-wrap: nowrap;
  position: relative;
  ::before,
  ::after {
    content: ""; /* Insert pseudo-element */
    margin: auto; /* Make it push flex items to the center */
  }
  @media(hover) {
    ::-webkit-scrollbar-track {
      background-color: var(--bg-paper);
      border-radius: 45px;
    }
    ::-webkit-scrollbar {
      height: 10px;
      background-color: var(--bg-paper);
      border-radius: 45px;
    }
    ::-webkit-scrollbar-thumb {
      background-image: linear-gradient(55deg, #a921dd 0%, #e71580 100%);
      border-radius: 45px;
    }
  }
`;

export const NavButton = styled(CircleButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  @media (max-width: 700px) {
    display: none;
  }
`;
export const PrevButton = styled(NavButton)`
  left: -100px;
  svg {
    margin-right: 1px;
  }
  @media (max-width: 1199px) {
    left: -60px;
  }
  @media (max-width: 700px) {
    left: 50%;
    transform: translate(-100px, -50%);
  }
`;
export const NextButton = styled(NavButton)`
  right: -100px;
  svg {
    margin-left: 2px;
  }
  @media (max-width: 1199px) {
    right: -60px;
  }
  @media (max-width: 700px) {
    left: 50%;
    right: auto;
    transform: translate(70px, -50%);
  }
`;
export const PlaceholderSlidesWrap = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  img {
    margin: 0 10px;
  }
`;
